type TIconSize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
type TIconVariant = 'secondary' | 'success' | 'error' | 'selected' | 'warning' | 'brand-secondary' | 'brand' | 'utility-gray' | 'brand-utility' | 'brand-icon' | 'utility-purple';

export enum IconName {
  Logo = 'logo',
  BrandLogo = 'brand-logo',
  Loading = 'loading',
  Lock = 'lock',
  EyeClosed = 'eye-closed',
  EyeOpen = 'eye-open',
  Mail = 'email',
  Alert = 'alert-circle',
  Backward = 'backward',
  Forward = 'forward',
  Organization = 'organization',
  Plus = 'plus',
  Check = 'check',
  CheckCircle = 'check-circle',
  Close = 'close',
  ArrowLeft = 'arrow-left',
  ArrowRight = 'arrow-right',
  ArrowDown = 'arrow-down',
  Search = 'search-lg',
  Home = 'home',
  Sun = 'sun',
  HelpCircle = 'help-circle',
  DollarCircle = 'dollar-circle',
  ClockCircle = 'clock-circle',
  SendMessage = 'send-message',
  Attachment = 'attachment',
  Code = 'code',
  Design = 'design',
  DesignSystem = 'design-system',
  More = 'more',
  Folder = 'folder',
  Link = 'link',
  Port = 'port',
  Credentials = 'credential',
  ListFiles = 'list-files',
  Web = 'web',
  Container = 'container',
  ProjectTree = 'project-tree',
  Delete = 'delete',
  Edit = 'edit',
  Read = 'read',
  Layout = 'layout',
  Thought = 'thought',
  Stop = 'stop',
  InfoCircle = 'info-circle',
  SearchLg = 'search-lg',
  LeftBox = 'left-box',
  FolderOpen = 'parent-folder',
  FolderClosed = 'normal-folder',
  ChevronDown = 'chevron-down',
  ChevronRight = 'chevron-right',
  CaretUp = 'caret-up',
  CaretDown = 'caret-down',
  Download = 'download',
  ExternalLink = 'external-link',
  Document = 'document',
  Preview = 'preview',
  PreviewUrl = 'preview-url',
  WebBrowser = 'web-browser',
  Reload = 'reload',
  File = 'file',
  Copy = 'copy',
  Cross = 'cross',
  Moon = 'moon',
  User = 'user',
  LogOut = 'logout',
  Dollar = 'dollar',
  Bell = 'bell',
  Gift = 'gift',
  Wallet = 'wallet',
  XClose = 'x-close',
  Shield = 'shield',
  ArrowNarrowUpRight = 'arrow-narrow-up-right',
  Run = 'run',
  Sort = 'sort',
  Upload = 'upload',
  UsersPlus = 'users-plus',
  Users = 'users',
  CopyLink = 'copy-link',
  DotsHorizontal = 'dots-horizontal',
  Share = 'share',
  DataModelPreview = 'datamodel-preview',
  Form = 'form',
  History = 'history',
  Rotate90Degrees = 'rotate_90_degrees',
  Skip = 'skip',
  Pause = 'pause',
  Table = 'table',
  Revert = 'revert',
  Schema = 'schema',
  FileDownload = 'file-download',
  PdfDownload = 'pdf-download',
  Pull = 'pull',
  Push = 'push',
  Tickets = 'tickets',
  Settings = 'settings',
  DollarSign = 'dollar-sign',
  CalendarDays = 'calendar-days',
  VideoRecording = 'video-recording',
  Fullscreen = 'fullscreen',
  PlaybackSpeed = 'playback-speed',
}

interface IIconProps {
  name: IconName;
  size?: TIconSize;
  className?: string;
  spin?: boolean;
  variant?: TIconVariant;
  inheritColor?: boolean;
};

export type
{
  IIconProps,
  TIconSize,
  TIconVariant,
};